<div class="kp-card text-justify p-5">
  <h1>توافق‌نامه کاربری</h1>
  <hr />

  <p>به سامانه کارپیشه بسیار خوش آمدید.</p>
  <p>شما ضمن استفاده از سامانه‌ی کارپیشه، شامل karpishe.com و سایر سایتها و ابزارهای مرتبط با آن، موافقت خود را با شرایط
    مندرج در این توافق‌نامه اعلام و تعهد به انجام مفاد آن را به شرح زیر قبول می‌فرمایید.</p>

  <ol style="list-style: decimal;">
    <li>از خدمات کارپیشه نباید در جهت اهداف غیر قانونی استفاده شود.</li>
    <li>هر گونه آسیب ناشی از رفتار و اقدامات کاربر که منجر به دین و بدهی به شخص ثالث گردد، بر عهده کاربر بوده و مسئولیتی
      از این حیث برای کارپیشه ایجاد نخواهد کرد.</li>
    <li>کاربران موافقت می‌کنند که از حقوق و منافع مشروع کارپیشه و دیگر کاربران حمایت و ضمانت به عمل آورند.</li>
    <li>هر گونه استفاده از اطلاعات مندرج در کارپیشه در هر شکلی که باعث نقض منافع تجاری کارپیشه می‌شود، همچون انتشار
      تبلیغات
      غیر مجاز تجاری یا غیرتجاری و غیره، مجاز نمی‌باشد.</li>
    <li>کارپیشه مجاز می‌باشد استفاده‌ی کاربر از خدمات خود را مورد بازنگری و نظارت قرار دهد.</li>
    <li>کارپیشه می‌تواند به تشخیص خود کلیه‌ی خدمات ارائه شده به کاربر را در هر زمان متوقف نماید و در مورد خدمات غیر
      رایگان، وجه باقیمانده از دوره‌ی ارائه‌ی خدمات را محاسبه و به کاربر بازگرداند.</li>
    <li>دریافت هرگونه وجه از کارجو تحت هر عنوان شامل هزینه ثبت‌نام، هزینه آموزش، خرید مواد اولیه یا خرید کالا غیر قانونی
      است. آگهی‌هایی که شامل این موارد باشند تایید و منتشر نخواهد شد. هزینه پرداخت شده برای این آگهی‌ها پس از کسر
      هزینه‌های اجرایی و کارمزد درگاه‌های پرداخت بعد از یک هفته به شماره کارت بانکی اعلام شده توسط کاربر واریز خواهد
      شد.</li>
  </ol>
  <p>با توجه به توسعه و تغییرات سریع بازار خدمات اینترنتی، کارپیشه مجاز است تا به طور منظم مفاد این قرارداد را بازنگری و
    اصلاح نماید و قرارداد جدید را در همین صفحه منتشر نماید.</p>
  <p>کارپیشه مجاز می‌باشد تا به صورت یک جانبه این قرارداد را تحت شرایط زیر خاتمه دهد.</p>

  <ul style="list-style: decimal;">
    <li>هرگونه عدول از تعهدات و مقررات مندرج در این قرارداد.</li>
    <li>ایجاد مزاحمت به هر نحو و مشاهده‌ی رفتارهای غیر متعارف از کاربر که موجب اختلال در ارائه خدمات کارپیشه گردد.</li>
  </ul>
</div>